import { combineLatestTyped, useStreamEffect } from 'annotation-tools/utils';
import React, { FC, memo } from 'react';
import { createProjectImage } from '../../../../api/fetch-functions/project-image';
import { token$ } from '../../../../global-state/auth-state';
import { fetchProjectImageListOf } from '../../../../global-state/database/project-image-list';
import { projectId$ } from '../../../../global-state/router-id';
import { useTusUploaderSingleFile } from '../../../../tus-image-upload/use-tus-uploader-single-file';
import { DndFileUploadAreaView } from '../../../shared/dnd-file-upload-area-view';

export const DndFileUploadArea: FC<{}> = memo(() => {
  const {
    dropzoneRootProps,
    dropzoneInputProps,
    isDragActive,
    autoHideErrorMessage,
    isUploading,
    uploadPercentage,
    cancelOnClick,
    uploadCompletedFileGuid$
  } = useTusUploaderSingleFile(3000);

  /* effect */

  useStreamEffect(
    combineLatestTyped(token$, uploadCompletedFileGuid$, projectId$),
    ([token, fileGuid, projectId]) => {
      if (
        token !== undefined &&
        projectId !== undefined &&
        fileGuid !== undefined
      ) {
        createProjectImage(token)(projectId)({ fileGuid }).then(res => {
          if (res.type === 'success') {
            fetchProjectImageListOf(projectId);
          }
        });
      }
    }
  );

  return (
    <DndFileUploadAreaView
      dropzoneRootProps={dropzoneRootProps}
      dropzoneInputProps={dropzoneInputProps}
      isDragActive={isDragActive}
      errorMessage={autoHideErrorMessage}
      isUploading={isUploading}
      uploadPercentage={uploadPercentage}
      cancelUploading={cancelOnClick}
    />
  );
});

DndFileUploadArea.displayName = 'DndFileUploadArea';
